import {
  endpoints as adminShopEndpoints,
  entity as adminShopEntity,
  listNormalizer as adminShopListNormalizer,
} from './adminShop';
import {
  entity as auditLogEntity,
  listNormalizer as auditLogListNormalizer,
  normalizer as auditLogNormalizer,
} from './auditLog';
import {
  entity as batchSettlementsEntity,
  listNormalizer as batchSettlementsListNormalizer,
} from './batchSettlements';
import {
  entity as brandEntity,
  listNormalizer as brandListNormalizer,
  normalizer as brandNormalizer,
} from './brand';
import {
  entity as ccTerminalEntity,
  listNormalizer as ccTerminalListNormalizer,
  listTransformer as ccTerminalListTransformer,
  normalizer as ccTerminalNormalizer,
  transformer as ccTerminalTransformer,
} from './ccTerminal';
import {
  entity as customerModulesEntity,
  listNormalizer as customerModulesListNormalizer,
  normalizer as customerModulesNormalizer,
} from './customerModules';
import {
  entity as gatewayEntity,
  listNormalizer as gatewayListNormalizer,
  listTransformer as gatewayListTransformer,
  normalizer as gatewayNormalizer,
  transformer as gatewayTransformer,
} from './gateway';
import {
  entity as gatewayConfigEntity,
  listNormalizer as gatewayConfigListNormalizer,
  listTransformer as gatewayConfigListTransformer,
  normalizer as gatewayConfigNormalizer,
  transformer as gatewayConfigTransformer,
} from './gatewayConfig';
import {
  entity as industriesEntity,
  listNormalizer as industriesListNormalizer,
} from './industries';
import {
  entity as integratedPaymentsEntity,
  listNormalizer as integratedPaymentsListNormalizer,
} from './integratedPayments';
import {
  entity as paymentTypeEntity,
  listNormalizer as paymentTypeListNormalizer,
  listTransformer as paymentTypeListTransformer,
  normalizer as paymentTypeNormalizer,
  transformer as paymentTypeTransformer,
} from './paymentType';
import {
  entity as preAuthorizationEmailEntity,
  listNormalizer as preAuthorizationEmailListNormalizer,
  listTransformer as preAuthorizationEmailListTransformer,
  normalizer as preAuthorizationEmailNormalizer,
  transformer as preAuthorizationEmailTransformer,
} from './preAuthorizationEmail';
import { entity as settlementEntity, normalizer as settlementNormalizer } from './settlement';
import {
  entity as settlementTransactionsEntity,
  listNormalizer as settlementTransactionsListNormalizer,
} from './settlementTransactions';
import {
  entity as shopEntity,
  listNormalizer as shopListNormalizer,
  listTransformer as shopListTransformer,
  normalizer as shopNormalizer,
  transformer as shopTransformer,
} from './shop';
import {
  entity as staffEcomLanguageEntity,
  listNormalizer as staffEcomLanguageListNormalizer,
} from './staffEcomLanguage';
import { entity as staffShopEntity, listNormalizer as staffShopListNormalizer } from './staffShop';
import {
  entity as terminalEntity,
  listNormalizer as terminalListNormalizer,
  listTransformer as terminalListTransformer,
  normalizer as terminalNormalizer,
  transformer as terminalTransformer,
} from './terminal';
import {
  endpoints as vendorEndpoints,
  entity as vendorEntity,
  listNormalizer as vendorListNormalizer,
  normalizer as vendorNormalizer,
} from './vendor';
import { endpoints as vendorNumberEndpoints } from './vendorNumber';
import {
  endpoints as vendorReturnItemEndpoints,
  entity as vendorReturnItemEntity,
  listNormalizer as vendorReturnItemListNormalizer,
  normalizer as vendorReturnItemNormalizer,
} from './vendorReturnItem';
import {
  endpoints as vendorReturnItemReasonEndpoints,
  entity as vendorReturnItemReasonEntity,
  listNormalizer as vendorReturnItemReasonListNormalizer,
  normalizer as vendorReturnItemReasonNormalizer,
} from './vendorReturnItemReason';
import { endpoints as vendorReturnItemTaxEndpoints } from './vendorReturnItemTax';
import { endpoints as vendorReturnResetItemTax } from './vendorReturnResetItemTax';
import {
  endpoints as vendorReturnsEndpoints,
  entity as vendorReturnsEntity,
  listNormalizer as vendorReturnsListNormalizer,
  normalizer as vendorReturnsNormalizer,
} from './vendorReturns';

export const entities = {
  auditLog: auditLogEntity,
  batchSettlements: batchSettlementsEntity,
  brand: brandEntity,
  customerModules: customerModulesEntity,
  ccTerminal: ccTerminalEntity,
  ecomConfirmation: 'ecomConfirmation',
  ecomIntegration: 'ecomIntegration',
  gateway: gatewayEntity,
  gatewayConfig: gatewayConfigEntity,
  industries: industriesEntity,
  preAuthorizationEmail: preAuthorizationEmailEntity,
  integratedPayments: integratedPaymentsEntity,
  paymentTransactionFilters: 'paymentTransactionFilters',
  paymentType: paymentTypeEntity,
  settlement: settlementEntity,
  settlementTransactions: settlementTransactionsEntity,
  adminShop: adminShopEntity,
  shop: shopEntity,
  staffEcomLanguage: staffEcomLanguageEntity,
  staffShop: staffShopEntity,
  shopDetails: 'shopDetails',
  taxSettings: 'taxSettings',
  vendor: vendorEntity,
  vendorReturns: vendorReturnsEntity,
  vendorReturnItem: vendorReturnItemEntity,
  vendorReturnItemReason: vendorReturnItemReasonEntity,
  terminal: terminalEntity,
};

export const endpoints = {
  adminShop: adminShopEndpoints,
  vendor: vendorEndpoints,
  vendorReturns: vendorReturnsEndpoints,
  vendorReturnItem: vendorReturnItemEndpoints,
  vendorReturnItemTax: vendorReturnItemTaxEndpoints,
  vendorReturnResetItemTax,
  vendorReturnItemReason: vendorReturnItemReasonEndpoints,
  vendorNumber: vendorNumberEndpoints,
};

export const normalizer = {
  auditLog: auditLogNormalizer,
  brand: brandNormalizer,
  customerModules: customerModulesNormalizer,
  ccTerminal: ccTerminalNormalizer,
  gateway: gatewayNormalizer,
  gatewayConfig: gatewayConfigNormalizer,
  paymentType: paymentTypeNormalizer,
  preAuthorizationEmail: preAuthorizationEmailNormalizer,
  settlement: settlementNormalizer,
  shop: shopNormalizer,
  vendor: vendorNormalizer,
  vendorReturns: vendorReturnsNormalizer,
  vendorReturnItem: vendorReturnItemNormalizer,
  vendorReturnItemReason: vendorReturnItemReasonNormalizer,
  terminal: terminalNormalizer,
};

export const listNormalizer = {
  auditLog: auditLogListNormalizer,
  batchSettlements: batchSettlementsListNormalizer,
  brand: brandListNormalizer,
  customerModules: customerModulesListNormalizer,
  ccTerminal: ccTerminalListNormalizer,
  gateway: gatewayListNormalizer,
  gatewayConfig: gatewayConfigListNormalizer,
  industries: industriesListNormalizer,
  preAuthorizationEmail: preAuthorizationEmailListNormalizer,
  integratedPayments: integratedPaymentsListNormalizer,
  paymentType: paymentTypeListNormalizer,
  settlementTransactions: settlementTransactionsListNormalizer,
  adminShop: adminShopListNormalizer,
  shop: shopListNormalizer,
  staffEcomLanguage: staffEcomLanguageListNormalizer,
  staffShop: staffShopListNormalizer,
  vendor: vendorListNormalizer,
  vendorReturns: vendorReturnsListNormalizer,
  vendorReturnItem: vendorReturnItemListNormalizer,
  vendorReturnItemReason: vendorReturnItemReasonListNormalizer,
  terminal: terminalListNormalizer,
};

export const transformer = {
  ccTerminal: ccTerminalTransformer,
  gateway: gatewayTransformer,
  gatewayConfig: gatewayConfigTransformer,
  paymentType: paymentTypeTransformer,
  preAuthorizationEmail: preAuthorizationEmailTransformer,
  shop: shopTransformer,
  terminal: terminalTransformer,
};

export const listTransformer = {
  ccTerminal: ccTerminalListTransformer,
  gateway: gatewayListTransformer,
  gatewayConfig: gatewayConfigListTransformer,
  paymentType: paymentTypeListTransformer,
  preAuthorizationEmail: preAuthorizationEmailListTransformer,
  shop: shopListTransformer,
  terminal: terminalListTransformer,
};
